import { render, staticRenderFns } from "./CustomerPaFinalization.vue?vue&type=template&id=deca3de8"
import script from "./CustomerPaFinalization.vue?vue&type=script&lang=js"
export * from "./CustomerPaFinalization.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/customer-pa.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports